import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useAuth } from '../../context/AuthContext';

const Icon = ({ children }) => <svg className="h-[22px] w-[22px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{children}</svg>;

function MobileBottomNav() {
  const { pathname } = useLocation();
  const { cart } = useCart();
  const { user } = useAuth();
  const count = cart.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
  const hidden = pathname === '/checkout' || pathname === '/order-confirmation';
  if (hidden) return null;

  const links = [
    { to: '/', label: 'Home', icon: <Icon><path d="m3 10 9-7 9 7"/><path d="M5 9v12h14V9"/><path d="M9 21v-7h6v7"/></Icon> },
    { to: '/restaurants', label: 'Explore', icon: <Icon><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></Icon> },
    { to: '/cart', label: 'Basket', badge: count, icon: <Icon><path d="M4 5h2l2 10h9l2-7H7"/><circle cx="10" cy="19" r="1"/><circle cx="17" cy="19" r="1"/></Icon> },
    { to: user ? '/dashboard' : '/login', label: user ? 'Account' : 'Sign in', icon: <Icon><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></Icon> },
  ];

  return <nav className="mobile-bottom-nav" aria-label="Mobile navigation">{links.map((link) => { const active = link.to === '/' ? pathname === '/' : pathname.startsWith(link.to); return <Link key={link.to} to={link.to} className={`mobile-bottom-link ${active ? 'is-active' : ''}`}><span className="relative">{link.icon}{link.badge > 0 && <span className="absolute -right-3 -top-2 grid h-4 min-w-4 place-items-center rounded-full bg-primary px-1 text-[9px] font-black text-white">{link.badge > 99 ? '99+' : link.badge}</span>}</span><span>{link.label}</span></Link>; })}</nav>;
}

export default MobileBottomNav;
